// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__ePKNe","header":"ClearentDisclaimer_header__2uHqP","inner":"ClearentDisclaimer_inner__BUFLX"};